import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { OmniLogo } from "./OmniLogo";
import { SUPPORT_URL } from "../../config/omni";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      data-testid="omni-navbar"
      className="fixed top-0 inset-x-0 z-50"
    >
      <div
        className={`mx-auto flex items-center justify-between px-5 sm:px-8 lg:px-12 transition-[background-color,border-color,padding] duration-500 ${
          scrolled
            ? "py-3 bg-[#131315]/70 backdrop-blur-xl border-b border-white/10"
            : "py-5 sm:py-7 bg-transparent border-b border-transparent"
        }`}
      >
        <OmniLogo className="text-[#fafafa]" />

        <a
          href={SUPPORT_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-support-cta"
          className="group inline-flex items-center gap-2 rounded-full bg-[#f5a623] px-4 py-2 text-[#0a0a0b] font-semibold text-sm transition-transform duration-300 hover:-translate-y-0.5"
        >
          <Heart
            size={15}
            className="fill-[#0a0a0b] transition-transform duration-300 group-hover:scale-110"
          />
          <span>
            Support
            <span className="text-[#0a0a0b]/60 font-medium"> / Sostieni</span>
          </span>
        </a>
      </div>
    </motion.header>
  );
};
